import { buildUrlPath } from "lib/resolveUrl";
import { authFetch } from "./base";
import { Result } from "monadix/result";
export const fetchTestRecordings = async () => {
    const response = await authFetch(`api/testing/recordings`);
    if (!response.ok) {
        const json = await response.json();
        if ('errors' in json) {
            const errors = json.errors;
            const firstError = errors[0];
            switch (firstError.code) {
                case 'NO_INDEX_FILE':
                    return Result.fail('NO_INDEX_FILE');
                case 'INVALID_INDEX_FILE':
                    return Result.fail('INVALID_INDEX_FILE');
                default:
                    return Result.fail('UNKNOWN_ERROR');
            }
        }
        throw new Error('Unexpected error format');
    }
    const json = await response.json();
    const recordings = json.data;
    return Result.success(recordings.map((recording) => ({
        ...recording,
        path: buildUrlPath(recording.path),
    })));
};
